export const LOGGED_USER = {
    USER_LOGGED_IN: 'LOGGED_USER.USER_LOGGED_IN',
    USER_LOGGED_OUT: 'LOGGED_USER.USER_LOGGED_OUT'
}